import React from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTransactionModel } from "./transactionModel";
import { IAllotAccountTransactionDetail } from "../../AccountTypes";

const columns: ColumnsType<IAllotAccountTransactionDetail> = [
    {
        align: "center",
        title: '序号',
        render: (_v, _r, i) => i + 1
    },
    {
        align: "center",
        title: '调拨单位',
        dataIndex: 'shopName',
    },

    {
        align: "center",
        title: '欠款',
        dataIndex: 'debtAmount',
    },
];

export function TransactionDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useTransactionModel();

    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAllotAccountTransactionDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
